import type { Locale } from 'date-fns';
import { enUS, es, fr, ptBR } from 'date-fns/locale';
import { getAppLanguage, type AppLanguageCode } from '@/i18n/languages';

const DATE_FNS_LOCALE_BY_LANGUAGE: Record<AppLanguageCode, Locale> = {
  fr,
  en: enUS,
  es,
  pt: ptBR,
};

export function getDateFnsLocale(lng: string | null | undefined): Locale {
  return DATE_FNS_LOCALE_BY_LANGUAGE[getAppLanguage(lng).code];
}
